let NonControlledHitterStacking = {
    MLB_NON_CONTROLLED_STACK_MAX_GROUPS: 2,
    MLB_NON_CONTROLLED_STACK_MIN_PLAYERS_QUANTITY: 2,

    MLB_NON_CONTROLLED_FIRST_GROUP: 1,
    MLB_NON_CONTROLLED_SECOND_GROUP: 2,

    NON_CONTROLLED_HITTER_STACKING_PROJECTION_MULTIPLY_VALUE: 100,
    NHL_TEAM_STACKING_PROJECTION_MULTIPLY_VALUE: 100,

    NON_CONTROLLED_HITTER_STACKING_IS_USED: 'NON_CONTROLLED_HITTER_STACKING_IS_USED',
    NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS: 'NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS',
    NON_CONTROLLED_HITTER_STACKING_SET_COMBO_IS_CHECKED: 'NON_CONTROLLED_HITTER_STACKING_SET_COMBO_IS_CHECKED',
    NON_CONTROLLED_HITTER_STACKING_SET_COMBO_EXPOSURE: 'NON_CONTROLLED_HITTER_STACKING_SET_COMBO_EXPOSURE',
    NON_CONTROLLED_HITTER_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY:
        'NON_CONTROLLED_HITTER_STACKING_SET_TEAMS_ARE_CHOSEN_RANDOMLY',
    NON_CONTROLLED_HITTER_STACKING_SET_PLAYERS_QUANTITY: 'NON_CONTROLLED_HITTER_STACKING_SET_PLAYERS_QUANTITY',
    NON_CONTROLLED_HITTER_STACKING_SET_TEAMS: 'NON_CONTROLLED_HITTER_STACKING_SET_TEAMS',
    NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_IS_CHECKED:
        'NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_IS_CHECKED',
    NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_EXPOSURE: 'NON_CONTROLLED_HITTER_STACKING_SET_STACK_TEAMS_EXPOSURE',
    NON_CONTROLLED_HITTER_STACKING_SET_BATTING_ORDER: 'NON_CONTROLLED_HITTER_STACKING_SET_BATTING_ORDER',
    NON_CONTROLLED_HITTER_STACKING_SET_TEAM_IS_CHECKED: 'NON_CONTROLLED_HITTER_STACKING_SET_TEAM_IS_CHECKED',
    NON_CONTROLLED_HITTER_STACKING_SET_TEAM_EXPOSURE: 'NON_CONTROLLED_HITTER_STACKING_SET_TEAM_EXPOSURE',
    NON_CONTROLLED_HITTER_STACKING_SET_DATA_FROM_STORAGE: 'NON_CONTROLLED_HITTER_STACKING_SET_DATA_FROM_STORAGE',
    NON_CONTROLLED_HITTER_STACKING_MIRROR_STACK: 'NON_CONTROLLED_HITTER_STACKING_MIRROR_STACK',
};

export default NonControlledHitterStacking;
